export default __webpack_public_path__ + "static/about_us_new-a93fea861e2fcf5495ca4ec3c518e0d5.jpg";